import { render, staticRenderFns } from "./WinnersList.vue?vue&type=template&id=08672182&scoped=true&"
import script from "./WinnersList.vue?vue&type=script&lang=js&"
export * from "./WinnersList.vue?vue&type=script&lang=js&"
import style0 from "./WinnersList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08672182",
  null
  
)

export default component.exports